//REGISTER
export const POST_FAKE_REGISTER = "/auth/signup";

//LOGIN
export const POST_FAKE_LOGIN = "/api/auth/token/";
export const POST_REFRESH_URL = "/api/auth/token_refresh/";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/api/auth/reset_password/";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";

// API Key
export const GET_API_KEY = "/apikey";
export const ADD_NEW_API_KEY = "/add/apikey";
export const UPDATE_API_KEY = "/update/apikey";
export const DELETE_API_KEY = "/delete/apikey";

// Contacts
export const GET_CONTACTS = "/get-contacts";
export const ADD_NEW_CONTACT = "/add/contacts";
export const UPDATE_CONTACT = "/update/contacts";
export const DELETE_CONTACT = "/delete/contacts";

 //todo
export const GET_TODO_LIST = "/todo-list";
export const ADD_TODO_LIST = "/add/todo-list";
export const UPDATE_TODO_LIST = "/edit/todo-list";
export const DELETE_TODO = "/delete/todo-list";

// todo Insights
export const GET_INSIGHTS = "/todo-insights";
export const ADD_INSIGHTS = "/add/todo-list";

// todo project
export const GET_PROJECT = "/todo-project";
export const ADD_PROJECT = "/add/todo-list";

//Mailbox
export const GET_MAIL_DETAILS = "/mail";
export const DELETE_MAIL = "/delete/mail";
export const UNREAD_MAIL = "/unread/mail";
export const STARED_MAIL = "/stared/mail";
export const LABEL_MAIL = "/label/mail";
export const TRASH_MAIL = "/trash/mail";

// Chat
export const GET_DIRECT_CONTACT = "/chat";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "add/message";
export const GET_CHANNELS = "/channels";
export const DELETE_MESSAGE = "delete/message";

// kanban
export const GET_TASKS = "/apps/tasks";
export const ADD_TASKS = "/add/tasks";
export const UPDATE_TASKS = "/update/tasks";
export const DELETE_TASKS = "/delete/tasks";
